import ContactWidgetStyles from '../styles/contactWidgetStyles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import React, {useState, useRef} from 'react';
import Views from '../lib/views';
import { Button, FormControl, InputAdornment, Input, InputLabel, Typography} from '@material-ui/core';
import { darken } from '@material-ui/core/styles';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import SearchIcon from '@material-ui/icons/Search';
import { __ } from '../lib/localization';

const getColor = (props) => props.backgroundColor;
const getColorDark = (props) => darken(props.backgroundColor, .1);

const styles = {
    root: {
        width: '100%',
        marginBottom: '14px',
        background: getColor,
        height: '45px',
        justifyContent: 'space-between',
        boxShadow: '0px 4px 8px rgba(25, 38, 57, 0.2)',
        borderRadius: '21px',
        '&:last-child': {
            marginBottom: '0px',
            label: {
                color: 'orange'
            }
        },
        '&:hover': {
            background: getColorDark,
        }
    }
}

const ProfileButton = withStyles(styles)(({ backgroundColor, ...other }) => (
    <Button {...other} />
));

const ProfileSelect = (props) => {
    const showSearchView = props.profiles.length > 4;
    const [filteredProfiles, setFilteredProfiles] = useState(props.profiles);
    const [filterTerms, setFilterTerms] = useState('');
    const searchRef = useRef(null);

    const onProfileClick = (profile) => {
        props.Analytics.trackEvent('profile', profile.label);
        props.setActiveProfile(profile);
    };

    const handleClearFilterTerms = () => {
        setFilterTerms('');
        filterProfiles('');
        searchRef?.current?.focus();
    }

    let profiles = props.profiles?.length ? props.profiles.map((item, index) => {
        return <ProfileButton
            key={item.uuid}
            backgroundColor={props.buttonBackgroundColor}
            onClick={ () => onProfileClick(item) }
            classes={
                {
                    label: props.classes.channel_button,
                }
            }
        >
            {item.label}
        </ProfileButton>
    }) : null;

    let filteredProfileList = filteredProfiles && filteredProfiles.length > 0 ? filteredProfiles.map((item, index) => {
        return <ListItem button
            backgroundColor={props.buttonBackgroundColor}
            onClick={ () => onProfileClick(item) }
            dense={true}
            classes={
                {
                    label: props.classes.button__label,
                    root: props.classes.profileListItem,
                }
            }
        >
            <ListItemText
                primary={
                    <Typography
                        classes={{root: props.classes.profileListItemTypography}}
                    >
                        <strong>{item.label}</strong>
                        {item.address ? (
                            <Typography
                                color="textSecondary"
                                style={{fontSize: "14px", textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap"}}
                                title={item.address}
                            >
                                <div dangerouslySetInnerHTML={{ __html: item.displayAddress ?? item.address}}></div>
                            </Typography>
                        ) : (<></>)}
                    </Typography>
                }
                secondary=""
            ></ListItemText>
        </ListItem>
    }) : <ListItem><ListItemText><Typography color="textSecondary">{ __('leadbox_no_result') }</Typography></ListItemText></ListItem>;

    // where `value` is the value of keywords typed into a search input
    const filterProfiles = (value) => {
        setFilterTerms(value);
        const searchTokens = value.toLowerCase().split(/[^a-z0-9\-_]+/ig).filter((i) => { return i; });
        const matches = props.profiles.filter((item) => {
            return searchTokens.length === 0 ||
                searchTokens.reduce((matchFound, token) => {
                    return matchFound
                        || item.label?.toLowerCase()?.indexOf(token) > -1
                        || item.address?.toLowerCase()?.indexOf(token) > -1;
                }, false)
        })
        .map(item => {
            item.displayAddress = item.address;
            if (item.address.length) {
                searchTokens
                    .forEach(token => {
                        let matchPosition = item.displayAddress?.toLowerCase()?.indexOf(token);
                        if (matchPosition > -1) {
                            let rxToken = new RegExp('('+token+')', 'ig');
                            item.displayAddress = item.displayAddress.replace(rxToken, '{$1}')
                        }
                 });
                item.displayAddress = item.displayAddress
                    .replaceAll('{', '<span class="list-result-match">')
                    .replaceAll('}', '</span>');
            }
            return item;
        });

        setFilteredProfiles(matches);
    };

    return (
        showSearchView ?
        <div>
            <div className={`${props.classes.home__body} isCompact`}>
				<FormControl fullWidth>
					<Input
                        className={`${props.classes.root} isKeywordSearch`}
						id="Keywords"
                        placeholder={ __('leadbox_search_hint') }
						onFocus={() => { props.Analytics.trackEvent('form-field', 'location search')}}
						onChange={(e) => { filterProfiles(e.target.value) }}
                        onBlur={(e) => { props.Analytics.trackEvent('search', e.target.value )}}
                        value={filterTerms}
                        inputProps={{'aria-label': __('leadbox_aria_search')}}
                        type="search"
                        inputRef={searchRef}
                        startAdornment={
                            <InputAdornment position="start">
                                <SearchIcon style={{color: '#A8A8A8', margin: '0 auto'}}/>
                            </InputAdornment>
                        }
                        endAdornment={
                            filterTerms !== "" ? (
                                <InputAdornment onClick={handleClearFilterTerms} position="end">
                                    <CloseIcon className={props.classes.clearFilterTermsIcon}
                                        aria-label="{ __('leadbox_aria_clear_search') }"
                                        role="button"
                                        aria-hidden="false"
                                        tabindex="0"
                                        focusable="true"
                                        onKeyPress={handleClearFilterTerms}
                                    />
                                </InputAdornment>
                            ) : (<></>)
                        }
					/>
				</FormControl>
				<div className={props.classes.searchResults}>
					<List>
						{filteredProfileList}
					</List>
				</div>
            </div>
            <div className={props.classes.form__triangle}></div>
        </div>
        :
        <div>
            <div className={props.classes.home__body}>
                {profiles}
            </div>
            <div className={props.classes.form__triangle}></div>
        </div>
    )
}

export default ProfileSelect;
